import type { IconSvgObject } from './types';

const CircleArrowDiagonal01Icon: IconSvgObject = [
  ["path", { d: "M11 16H8V13M13 8H16V11M8.49997 15.5L15.5 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowDiagonal01Icon;
